import { useEffect } from "react"
import Despiece from "./components/Despiece"
import { Content } from "./style"

const FreeHtml = ({ content, elementBodyId }) => {  
  // useEffect(()=>{
  //   if (content?.customData?.selectedView === "Especial"){
  //     const target = '.centeredContent';
  //     const element = document.querySelector(target);

  //     element.style.transform = `translateX(-${element.offsetLeft}px)`;
  //     element.style.setProperty('--offset', element.offsetLeft);

  //     window.addEventListener('resize', function () {
  //       element.style.transform = `translateX(-${element.offsetLeft}px)`;
  //       element.style.setProperty('--offset', element.offsetLeft);
  //     });
  //   }
  // },[])

  if (content?.customData?.selectedView === "Despiece") 
    return <Despiece className="freeHtml-embed" content={content} id={elementBodyId}/> 

  if (content?.value?.html && !content?.value?.html?.includes("trinity")) 


    return <Content className={`freeHtml-embed ${content?.customData?.selectedView}` }suppressHydrationWarning dangerouslySetInnerHTML={{ __html: content.value.html }} id={elementBodyId}/>


  // return <></>;
}

export default FreeHtml;
